
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignalStation as ObiSignalStationElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-signal-station.js';
 
 
 

 
 export const ObiSignalStation = createComponent({
   react: React,
   tagName: 'obi-signal-station',
   elementClass: ObiSignalStationElement,
   events: {
     
   }
  });
 
 